import { PROMISE_TYPE_SUFFIXES } from 'stores/redux/actions/types';

const [P, F, R] = PROMISE_TYPE_SUFFIXES;

export default function getPromiseTypes(TYPE) {
  return [`${TYPE}_${P}`, `${TYPE}_${F}`, `${TYPE}_${R}`];
}
